import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class BingUET extends AbstractDriver
{
    constructor()
    {
        super();
        this.firstLoad = false;
    }

    init(config)
    {
        if (!this.firstLoad)
            this._loadScript(config);
    }

    async pageView()
    {
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'page_view', { page_path: location.pathname });
    }

    async lead()
    {
        console.log('uet lead');
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'lead', {});
    }

    _exists(showErrors = false)
    {
        return true;
    }

    _loadScript(config)
    {
        //Load is handled by GTM

        return true;
    }
}

export default BingUET;
